module.exports = __webpack_public_path__ + "img/wxNull.7772fe91.svg";